<template>
	<button 
	:disabled="loading || disabled" 
	v-bind="$attrs" 
	@click="$emit('click', $event)"
	:class="[
		'btn btn-'+theme, 
		icon && !$slots.default ? 'btn-icon': ''
	]">

		<div 
		v-if="loading" 
		:class="[
			'spinner-border spinner-border-sm',
			$slots.default ? 'mr-2 me-2' : ''
		]">
			<span class="sr-only d-none">Loading...</span>
		</div>

		<i v-else-if="icon" :class="[
			'fe fe-'+icon,
			$slots.default ? 'small mr-2 me-2' : ''
		]"></i>

		<slot />
	</button>
</template>

<script>
	export default {
		props: {

			theme: {
				type: String,
				default: 'primary'
			},

			disabled: {
				type: Boolean,
				default: false
			},

			loading: [Number, Boolean],
			icon: String,
		},
	}
</script>
